//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_WorldCupBet, api_WorldCupDetail } from "@/api";
import { getWorldCupTeamName } from "@/utils/worldCupTeams";

export default {
  data() {
    return {
      loading: false,
      match: null,
      markets: [],
      myBets: [],
      recentBets: [],
      activeMarket: "WinDrawLose",
      selected: null,
      amount: null,
    };
  },
  computed: {
    hasScore() {
      return this.match && this.match.homeScore !== null && this.match.homeScore !== undefined;
    },
    currentMarkets() {
      return this.markets.filter((item) => item.marketType === this.activeMarket);
    },
    groupedCorrectScoreMarkets() {
      const groups = [
        { key: "home", title: "主胜比分", items: [] },
        { key: "draw", title: "平局比分", items: [] },
        { key: "away", title: "客胜比分", items: [] },
      ];
      this.markets
        .filter((item) => item.marketType === "CorrectScore")
        .forEach((item) => {
          const groupKey = this.getCorrectScoreGroup(item);
          const group = groups.find((x) => x.key === groupKey);
          if (group) group.items.push(item);
        });
      return groups.filter((group) => group.items.length > 0);
    },
    expectedPayout() {
      if (!this.selected || !this.amount) return "0.00";
      return (Number(this.amount) * Number(this.selected.odds || 0)).toFixed(2);
    },
    canBetNow() {
      return this.match && this.match.canBet && this.selected && this.amount >= 5;
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getPayload(res) {
      return (res && res.data && (res.data.data || res.data.Data)) || {};
    },
    getDetail() {
      this.loading = true;
      api_WorldCupDetail(this.$route.params.id)
        .then((res) => {
          const data = this.getPayload(res);
          this.match = data.match;
          this.markets = (this.match && (this.match.markets || this.match.Markets)) || [];
          this.myBets = data.myBets || [];
          this.recentBets = data.recentBets || [];
          this.selected = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    canSelect(item) {
      return this.match && this.match.canBet && item && Number(item.odds) > 0;
    },
    selectMarket(item) {
      if (this.canSelect(item)) this.selected = item;
    },
    submitBet() {
      if (!this.canBetNow) return;
      api_WorldCupBet({
        matchId: this.match.id,
        marketType: this.selected.marketType,
        selectionKey: this.selected.selectionKey,
        amount: this.amount,
      }).then((res) => {
        if (res.data && res.data.code === 0) {
          this.amount = null;
          this.getDetail();
        } else {
          alert((res.data && res.data.msg) || "下注失败");
        }
      });
    },
    marketName(value) {
      return value === "CorrectScore" ? "波胆" : "胜平负";
    },
    getCorrectScoreGroup(item) {
      if (!item) return "";
      if (item.selectionKey === "HomeOther") return "home";
      if (item.selectionKey === "DrawOther") return "draw";
      if (item.selectionKey === "AwayOther") return "away";
      const scores = String(item.selectionKey || "")
        .split("-")
        .map((value) => Number(value));
      if (scores.length !== 2 || scores.some((value) => Number.isNaN(value))) return "";
      if (scores[0] > scores[1]) return "home";
      if (scores[0] < scores[1]) return "away";
      return "draw";
    },
    statusName(value) {
      const names = { Pending: "待结算", Won: "已中奖", Lost: "未中奖", Refunded: "已退款" };
      return names[value] || value;
    },
    teamName(competitionCode, code, name) {
      return getWorldCupTeamName(code, name, competitionCode);
    },
    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      const pad = (num) => String(num).padStart(2, "0");
      return `${date.getMonth() + 1}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    formatOdds(value) {
      const num = Number(value || 0);
      return num > 0 ? num.toFixed(2) : "--";
    },
    competitionName(code) {
      const names = {
        WC: "世界杯",
        PL: "英超",
        PD: "西甲",
        SA: "意甲",
        BL1: "德甲",
        FL1: "法甲",
      };
      return names[code] || code || "";
    },
    getStatusName(status) {
      const names = {
        Scheduled: "未开赛",
        InPlay: "进行中",
        Finished: "已结束",
        Cancelled: "已取消",
        Postponed: "延期",
      };
      return names[status] || status || "-";
    },
    hideBrokenImage(event) {
      event.target.style.display = "none";
    },
  },
};
